import { useAsyncError } from '@/hooks/use-async-error';
import { useQrCode } from '@/hooks/use-qr-code';

type Props = {
  text?: string;
};

export function useMobileRedirectQrCode({ text }: Props) {
  const asyncError = useAsyncError();

  function handleError(error: Error) {
    asyncError(`Error generating QR code: ${error}`);
  }

  return useQrCode({ text, onError: handleError });
}
